var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgNowBoltFill = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 32,
  height: 32,
  fill: "#1B1F23",
  "aria-hidden": "true",
  viewBox: "0 0 32 32"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M20.68 2.161c.238-1.55-1.76-2.38-2.69-1.118L5.781 17.61C5.052 18.6 5.759 20 6.99 20h5.844l-1.513 9.839c-.239 1.55 1.76 2.38 2.69 1.118L26.218 14.39c.73-.99.023-2.39-1.207-2.39h-5.845z"
})));
export default SvgNowBoltFill;